import { setUserSetting, StorageKeys } from 'helpers';
import { Action } from 'redux';

export enum Types {
  TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
  SHOW_SESSION_EXPIRED_MODAL = 'SHOW_SESSION_EXPIRED_MODAL',
}

export interface IToggleSidebar extends Action {
  type: Types.TOGGLE_SIDEBAR;
  data: boolean;
}

export interface IShowSessionExpiredModal extends Action {
  type: Types.SHOW_SESSION_EXPIRED_MODAL;
}

export const ToggleSidebarAction = (data: boolean) => {
  return {
    type: Types.TOGGLE_SIDEBAR,
    data,
  } as IToggleSidebar;
};



export const ShowSessionExpiredAction = () =>
({
  type: Types.SHOW_SESSION_EXPIRED_MODAL,
} as IShowSessionExpiredModal);

export const ToggleSidebar = (expanded: boolean) => (dispatch) => {
  setUserSetting(StorageKeys.SIDEBAR, true);
  dispatch(ToggleSidebarAction(expanded));
};


